import { Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { tryParseToMoment } from './format-datetime.pipe';

// "3 days ago", or in another registered moment locale — `'th'` gives
// "3 วันที่แล้ว". The locale applies to this value only: main.ts registers
// the Thai locale and keeps the global default English, so every other page
// stays English. Unparseable input comes back unchanged.
export const formatRelativeDatetime = (
    value: unknown,
    locale?: string,
): unknown => {
    const parsed = tryParseToMoment(value);
    if (!moment.isMoment(parsed)) {
        return parsed;
    }
    return locale ? parsed.clone().locale(locale).fromNow() : parsed.fromNow();
};

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'formatRelativeDatetime' })
export class FormatRelativeDatetimePipe implements PipeTransform {
    transform(value: unknown, locale?: string): unknown {
        return formatRelativeDatetime(value, locale);
    }
}
